var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.AppDetailPage,{staticClass:"pa-5",attrs:{"title":"","backRouteName":"Applicants"}},[(_setup.loading)?_c('Loader',{attrs:{"full-page":true}}):[(_setup.applicant)?[_c(_setup.ApplicationDetail,{attrs:{"applicant":_setup.applicant}})]:_vm._e()]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }